// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid {
  display: grid;
}
.grid.spacing-4px {
  column-gap: 4px;
  row-gap: 4px;
}
.grid.spacing-8px {
  column-gap: 8px;
  row-gap: 8px;
}
.grid.spacing-12px {
  column-gap: 12px;
  row-gap: 12px;
}
.grid.spacing-16px {
  column-gap: 16px;
  row-gap: 16px;
}
.grid.spacing-32px {
  column-gap: 32px;
  row-gap: 32px;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Grid.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;AACJ;AACE;EACE,eAAA;EACA,YAAA;AACJ;AACE;EACE,gBAAA;EACA,aAAA;AACJ;AACE;EACE,gBAAA;EACA,aAAA;AACJ;AACE;EACE,gBAAA;EACA,aAAA;AACJ","sourcesContent":[".grid {\r\n  display: grid;\r\n\r\n  &.spacing-4px{\r\n    column-gap: 4px;\r\n    row-gap: 4px;\r\n  }\r\n  &.spacing-8px{\r\n    column-gap: 8px;\r\n    row-gap: 8px;\r\n  }\r\n  &.spacing-12px{\r\n    column-gap: 12px;\r\n    row-gap: 12px;\r\n  }\r\n  &.spacing-16px{\r\n    column-gap: 16px;\r\n    row-gap: 16px;\r\n  }\r\n  &.spacing-32px{\r\n    column-gap: 32px;\r\n    row-gap: 32px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
